import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
const RefreshLink = props => /*#__PURE__*/_jsx(UILink, Object.assign({
  onClick: () => window.location.reload()
}, props));
export default RefreshLink;